module.exports = __webpack_public_path__ + "assets/img/download.0afd7ff1.svg";